import React, { FC } from 'react';
import * as yup from 'yup';

import {
  InteractionInfo,
  OverlayComponentProps,
  VideoOverlayTypes,
} from '$/components/Interactions/InteractionInfo';
import {
  InteractionModalAccordionsHook,
  InteractionModalComponentProps,
  ModalValidationRules,
} from '$/components/Interactions/types';
import {
  AttendeeFragment,
  InteractionForAttendeeFragment,
  InteractionFragment,
  PublicEWebinarFragment,
  RoomType,
} from '$/GraphQL/schema/types';

import { StyleProps } from '$/components/ui';
import { OfferIcon } from '$/images/FontAwesomeIcons';
import { yupIsValidUrl } from '$/utils/isUrl';

import SpecialOfferCard from './OfferCard';
import OfferOverlayButton from './OfferOverlayButton';
import { AnalyticsCardProps } from '../cards/types';
import { useOfferSettings } from './useOfferSettings';

const AnalyticsClickCard = React.lazy(() => import('../cards/AnalyticsClickCard'));
const OfferModal = React.lazy(() => import('./OfferModal'));

export class OfferInfo extends InteractionInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public typeName(): string | undefined {
    return `Special offer`;
  }

  public icon(): React.FC<StyleProps> {
    return OfferIcon;
  }

  public modalValidationRules(): ModalValidationRules {
    return {
      ...super.modalValidationRules(),
      link: yupIsValidUrl().required(),
      buttonText: yup.string().trim().required(),
      showOverlayButton: yup.boolean().nullable(),
      overlayButtonText: yup
        .string()
        .nullable()
        .when('showOverlayButton', {
          is: true,
          then: (schema) => schema.required(),
        }),
    };
  }

  public hasExpiresInFieldToggle(): boolean {
    return true;
  }

  public hasExpiresInField(): boolean {
    return true;
  }

  public hasExpiresInReplayToggle(): boolean {
    return true;
  }

  public get endsAtPlaybackPosition(): number {
    return this.rooms.getRoom(RoomType.Exit).endsAt;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return OfferModal;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook {
    return useOfferSettings;
  }

  public cardBodyComponent(): React.FC {
    return SpecialOfferCard;
  }

  public isInteractiveOverlay(): boolean {
    return true;
  }

  public showOverlayEditor(): boolean {
    return false;
  }

  public hasVideoOverlay(): VideoOverlayTypes | null {
    return null; // this.details?.showOverlayButton ? 'over-video' : null;
  }

  public renderOverlayComponent(): FC<OverlayComponentProps> {
    return OfferOverlayButton;
  }

  public canSubmitMuktipleTimes(): boolean {
    return true;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsClickCard;
  }
}
